import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const STORAGE_KEY = 'loop_command_api_url';
const COMMAND_API_PATH = '/api/v1/command';

@Injectable()
export class DevCommandApiInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const localUrl = localStorage.getItem(STORAGE_KEY);
    if (!localUrl || !req.url.endsWith(COMMAND_API_PATH)) {
      return next.handle(req);
    }

    const overrideUrl = localUrl.replace(/\/$/, '') + COMMAND_API_PATH;
    return next.handle(req.clone({ url: overrideUrl }));
  }
}
